export default {
    "global": {
        "instructions": "Instructions of use",
        "action": "Action",
        "active": "Active",
        "inactive": "Inactive",
        "actions": "Actions",
        "add": "Add",
        "addkeyword": "Add a keyword",
        "addkeywords": "Add Keywords",
        "addsource": "Add a source",
        "all": "All",
        "amount": "Amount",
        "anchor": "Anchor text",
        "apply": "Apply",
        "article": "Article",
        "audit": "Audit",
        "available": "Available",
        "back": "Back",
        "brief": "Brief",
        "brief_partenaire": "Brief partner",
        "budget": "Budget",
        "bulkedit": "Bulk Edit",
        "cancel": "Cancel",
        "category": "Category",
        "categories": "Categories",
        "choose": "Choose",
        "client": "Client",
        "close": "Close",
        "columns": "Columns",
        "content": "Content",
        "copied": "Copied",
        "copy": "Copy",
        "created-at": "Created at",
        "credits": "Credits",
        "current-month": "Current month",
        "delete": "Delete",
        "deleteConfirmation": "Are you sure ?",
        "deleteConfirmationDesc": "This can't be undone",
        "deleteYes": "Yes, delete it",
        "desactivate": "Deactivate",
        "details": "Details",
        "disconnect": "Log out",
        "domain": "Domain",
        "done": "Done",
        "download": "Download",
        "earnings": "Earnings",
        "edit": "Edit",
        "elementbypage": "items by page",
        "email": "Email",
        "error": "Error",
        "error-url": "URL seems to be incorrect",
        "errors": "Errors",
        "event": "Event",
        "export": "Export",
        "filter": "Filter",
        "filters": "Filters",
        "here": "Here",
        "hi": "Hi",
        "hide": "Hide",
        "importantinformations": "Important Information",
        "included": "included",
        "invoicing": "Invoicing",
        "keyword": "Keyword",
        "keywords": "Keywords",
        "lastscrap": "Last scrap",
        "legalnotice": "Legal Notice",
        "link": "Link",
        "loading": "Loading",
        "locale": "Language",
        "maxprice": "Max. price",
        "minprice": "Min. price",
        "message": "Message",
        "modify": "Modify",
        "move": "Move",
        "moveproject": "Move to the project",
        "moovetoproject": "Move to a project",
        "month": "Month",
        "new": "New",
        "next": "Next",
        "no": "No",
        "none": "Aucun",
        "note": "Note",
        "options": "Options",
        "or": "or",
        "order": "Order",
        "orders": "Orders",
        "preorders": "Preorders",
        "other": "Other",
        "page": "Page",
        "payment": "Payment",
        "per-page": "Results per page",
        "prev": "Previous",
        "price": "Price",
        "priority": "Priority",
        "project": "Project",
        "quantity": "Volume",
        "reactivate": "Reactivate",
        "reason": "Reason",
        "recipient": "Recipient",
        "redaction": "Writing",
        "ref": "Ref.",
        "reinitialize": "Reinitialize",
        "research": "Search",
        "save": "Save",
        "show-search": "Show search fields",
        "send": "Send",
        "selectStatus": "Select status",
        "site": "Website",
        "sorry": "Sorry",
        "sites": "Websites",
        "sitesale": "Site Sale",
        "sites-types": {
            "gold": "Gold",
            "silver": "Silver",
            "bronze": "Bronze",
            "vip": "Gold VIP",
            "unknown": "Unknown"
        },
        "source": "Source",
        "stats": "Statistics",
        "status": "Status",
        "stop": "Stop",
        "success": "The action was successful",
        "tag": "Tag",
        "thankyou": "Thank you",
        "time": {
            "date": "Date",
            "duration": "Duration",
            "month": "month",
            "months": "months",
            "period": "Period",
            "year": "year"
        },
        "todo": "To do",
        "todelete": "To be deleted",
        "tovalidate": "To be validated",
        "theme": "Theme",
        "update": "Update",
        "validate": "Validate",
        "use": "Use",
        "verification": "Check",
        "words": "words",
        "yes": "Yes",
        "new-error": "An error has occurred",
        "url": "URL",
        "url-extension": "URL's extension",
        "show": "Show",
        "partner": "Partner"
    },
    "error": {
        "message": {
            "default": "An error occurred",
            "server": "Server error",
            "validation": "Error: invalid data"
        }
    },
    "campaign": {
        "new": "New campaign"
    },
    "language": {
        "title": "Language",
        "French": "French",
        "English": "English"
    },
    "user": {
        "email": "Email",
        "internet_bs_email": "internet.bs email",
        "firstname": "First name",
        "lastname": "Last name",
        "company": "Company",
        "address": "Address",
        "postal-code": "Postal Code",
        "city": "City",
        "country": "Country",
        "phone": "Phone",
        "api_key": "API key",
        "TVAnumber": "VAT number",
        "noTVA": "Exempt from VAT",
        "nosiretnumber": "I don't have a SIRET number",
        "siret": "SIRET",
        "attestation_siret": "Attestation SIRET",
        "attestation": {
            "attestation": "Attestation",
            "last_attestation_status": "Last Att.",
            "type": "Type",
            "urssaf": "URSSAF (A privilégié, Gratuit)",
            "urssaf_required": "URSSAF (mandatory)",
            "kbis": "Extrait de KBIS (Payant)",
            "insee": "Insee (Création d'entreprise récente)",
            "warning": "Only document less than 6 months old",
            "others": "Others"
        },
        "payment": {
            "accountnumber": "Account number",
            "bank": "Bank",
            "bankaccountowner": "Account owner",
            "bankadress": "Bank domiciliation ",
            "bankdepot": "Bank sort code",
            "bankname": "Name of the bank",
            "key": "Key",
            "mode": "Payment method",
            "paypaladress": "Paypal address",
            "paypal-fees": "Please note that Paypal bank fees will be charged to you",
            "rib": "Bank details",
            "save": "Set my payment information as default",
            "transfer": "Bank transfer",
            "validIBAN": "Please enter a valid IBAN"
        }
    },
    "users": {
        "modify": "Modify user"
    },
    "links&anchors": {
        "link": "Link",
        "link&anchor": "Link & anchor",
        "nolinksto": "Not containing links to",
        "pageanchors": "Page anchor texts",
        "targetlink": "Targeted link ",
        "targetlink2": "Targeted link 2",
        "wantedlink": "Requested link ",
        "wantedlinks": " Requested link(s)",
        "wantedlink2": "Requested link 2",
        "wantedanchor": "Requested anchor",
        "wantedanchors": "Requested anchor(s)",
        "wantedanchor2": "Requested anchor 2"
    },
    "suivi-admin": {
        "title": "Orders",
        "btn": " See expired orders"
    },
    "domain-posting": {
        "title": "DomainPosting"
    },
    "status": {
        "accepted": "Accepted",
        "activated": "Activated",
        "activated-s": "Activated",
        "attentevalidation": "Waiting for approval",
        "attentecustomer": "Waiting for customer",
        "canceled": "Canceled",
        "canceled-s": "Canceled",
        "deleted": "Deleted",
        "deactivated": "Deactivated",
        "desactivated-s": "Deactivated",
        "expired": "Expired",
        "finished": "Finished",
        "publication": "Ongoing publication",
        "published": "Published",
        "published-s": "Published",
        "redaction": "Ongoing writing",
        "refused": "Refused",
        "refused-s": "Refused",
        "running": "In progress",
        "stopped-(es)": "Stopped",
        "supressed-s": "Deleted",
        "validated": "Validated",
        "validated-es": "Validated",
        "waitingforvalidation": "Awaiting validation",
        "waitingforimprove": "Awaiting improvement"
    },
    "achat-credits": {
        "alert-transfer": "When making the transfer: Please indicate the reference of the invoice that you will receive by email as a reference for your transfer",
        "amount": "€ HT, your payment will be ",
        "creditgain": "% additional credits",
        "minimumamount": "Please enter an amount higher or equal to  ",
        "payment-card": "Payment by card",
        "payment-transfer": "Payment by bank transfer",
        "payment-transfer-preference": "You prefer to pay by bank transfer ?",
        "payment-transferdescription": "If you wish, you can pay by bank transfer. Credits will be added to the platform upon receipt. You will find the bank information to use bellow",
        "promocode": "Enter a discount code (optionnal)",
        "promocodeenter": "Do you have a coupon code ?",
        "promocodenotvalid": "This discount code is not valid",
        "promocodeuse": "You are going to use the discount code ",
        "promocodeused": "You have already used this discount code",
        "save": "Save the information",
        "sorry": "Sorry",
        "thatbeing": "that being ",
        "title": "Buy credits",
        "subtitle": "Take advantage with Nextlevel",
        "validation": "By validating, I undertake to make a bank transfer of",
        "validation_02": "Credits will be added to the platform upon receipt.",
        "wantedamount": "Enter the desired amount",
        "recap": "Summary",
        "payment-methods": "Means of payment: Credit card, Bank transfer",
        "apply": "Apply",
        "additional-info": "Any additional information ?",
        "useful-reference": "Please fill in any useful reference",
        "amount-title": "Amount",
        "designation-title": "Designation"
    },
    "achat-lien": {
        "restrictions": "Please note that the partner has put in place the following restrictions",
        "onelink": "Only one link allowed",
        "max": "is the maximum number of words the partner agrees to add to its content",
        "anchors": "Only the URL anchor texts or generic keywords (click here, to know more, etc) are allowed",
        "genericanchors": "Only the URL anchors, generic keywords (click here, to know more, etc) or non-optimized keywords are allowed",
        "plannedpublication": "planned publication is not possible",
        "noMFA": "do not accept MFA rivals"
    },
    "alertes": {
        "add": "Add an alert",
        "min": "Minimum:",
        "title": "Alerts",
        "searchquantity": "Volume",
        "setalert": "Add an alert",
        "wantedquantity": "Wished quantity"
    },
    "alertes-partenaires": {
        "addchild": "Add all the child categories",
        "addparent": "Add all the parent categories",
        "alertpartner": "Add a partner alert",
        "emptylist": "Empty the category list",
        "categoryalert": "Category alert",
        "daily": "Daily",
        "frequency": "Frequency",
        "getalerts": "Get alerts for the previous 2 months",
        "getkeywords": "Get keywords without interested partners",
        "libelle": "Title (example: general alert)",
        "monthly": "Monthly",
        "nointerested": "None interested",
        "modifyalert": "Modify an alert",
        "multipleselect": "Alert category (multiple selection)",
        "title": "My partner alerts",
        "text": "Title",
        "weekly": "Weekly"
    },
    "buylink": {
        "about": "About your order on the keyword",
        "buylink": "Buy link",
        "credits": "credits - Website",
        "incorectprice": "The price is incorrect",
        "impossible": "BUYING IS IMPOSSIBLE: You have already bought a link on this domain",
        "linkprice": "You bought the link for",
        "notenoughtcredit": "You don't have enought credit",
        "thanks": "Thanks for your order",
        "unavailablelink": "The link is no longer available"
    },
    "campaign-manager": {
        "notification": {
            "budget": {
                "extendError": "An error has occurred, cannot extend your campaign",
                "extendValidation": "Your campaign has been extended successfully {duration} month",
                "resetError": "An error has occurred, cannot reset your budgets",
                "resetValidation": "Your budgets has been reset successfully",
                "createError": "An error has occurred, cannot create your budgets",
                "createValidation": "Your budgets has been created successfully",
                "resetDialogTitle": "Reset budgets",
                "resetDialogMessage": "Do you really want to reset budgets with the default values ?"
            }
        }
    },
    "commande": {
        "back": "Back to preorders",
        "addkeyword": "Add a keyword",
        "addnote": "Add a note to the editor of your article",
        "available": "Available",
        "brief": "Brief",
        "clickhere": " by clicking here",
        "contact": "We will be in touch with you shortly to inform you about the evolution of your pre-order",
        "keyword": "Keyword (Example: Cruise) - 30 characters max",
        "maincategory": "Main category",
        "mainkeyword": "Main Keyword",
        "noproject": "No project found. To place a pre-order, you must create a project",
        "notsaved": "This line is not saved",
        "numberarticles": "Number of desired articles",
        "preorder": "Articles: pre-order",
        "preorderAction": "Pre-order my articles",
        "preorderarticles": "Pre-order articles",
        "remainingpreorders": "There are still {remainingPreorders} possible pre-order(s) for this project.",
        "secondarykeyword": "Secondary keywords",
        "secondarykeyworddescription": "Enter here keywords related to the main keyword. Our partners will more easily provide you with relevant results on these secondary keywords.",
        "secondarykeywords": "Secondary Keywords",
        "secondarykeywordempty": "An empty keyword will not be taken into account",
        "secondarykeywordexample": "Secondary keyword 1 (Example: Caribbean Cruise)",
        "toomany": "Quota exceeded. Please remove pre-orders for this project",
        "manageProjects": "Manage Projects",
        "goToProject": " by clicking here",
        "validation": {
            "front": {
                "name": "Name",
                "articlenumber": "Number of articles",
                "alreadyinlist": "The keyword is already in the list",
                "empty": " is empty",
                "low": " is too low",
                "issameasmain": "Secondary keyword can't be the same as the main keyword",
                "secondarykeyworderror": "Please, check your secondary keyword(s) for error(s)",
                "saved": "Save done",
                "saveddetails": "The data has been successfully saved. You can safely exit this page"
            }
        }
    },
    "detail-accompagnement": {
        "title": "Campaigns Details  "
    },
    "devenir-partenaire": {
        "advantages": "Once your website is validated, you have nothing more to do until you receive an e-mail notification that an order is placed on one of your websites",
        "advantages_02": "You will receive a percentage of the total price of the completed order excluding VAT",
        "advantages_04": "These percentages are specified in the terms and conditions",
        "advantages_05": "Then you can either withdraw your earnings or turn them into NextLevel credits",
        "advantagestitle": "WHAT'S IN IT FOR ME?",
        "contact": "Please let us know how to contact you if needed when dealing with your future orders (phone ou Skype).",
        "cgv": "I accept the terms and conditions*",
        "descriptiontitle": "HOW DOES IT WORK?",
        "description": "You add your website to NextLevel. When a user makes a search, NextLevel will display all the corresponding keywords positioned by all the websites (our websites as well as partner websites)",
        "description_02": "If an order is made on a parter's website, he will get an mail inviting him to accept or refuse the order. The details of this order will be available in the partner dashboard on NextLevel (brief, additional words...). After the order has been written, the partner only have to mark it as completed on his partner dashboard.",
        "description_03": "The partner has 10 working days to complete the order, and undertakes to respect the contract for at least 24 months. A control is carried out by NextLevel",
        "partsite": "It's possible! When registering a website, you have several possibilities",
        "partsite_02": "Indicate that only the urls of a sitemap are allowed, which allows you for example to only authorize your blog posts, and not your pages or categories, or tags.",
        "partsite_03": "Using a txt file, you can also forbid a list of urls",
        "partsitetitle": "I DO NOT WANT TO SUBMIT MY WHOLE WEBSITE",
        "title": "Become Partner",
        "partneryes": "Yes, I want to become a NextLevel partner",
        "redaction": "For each added website, you indicate if you want to edit the contents or if you entrust NextLevel with the editing",
        "redaction_02": "This way, you can either respect your editorial line or choose not to take care of anything except the publication of the text provided.",
        "redactiontitle": "WE WRITE OR YOU WRITE, YOU CHOOSE",
        "sitetype": "We accept Wordpress websites as well as other.",
        "sitetype_02": "Each website is manually accepted. Your website will be subject to inspection and we retain the right to decline your application if the quality is insufficient.",
        "sitetype_03": "All the themes are accepted but websites must comply with the laws in force.",
        "sitetypetitle": "WHAT TYPE OF WEBSITE DO YOU ACCEPT?",
        "welcome": "Welcome on behalf of the NextLevel team "
    },
    "emails": {
        "assist": "If you have any problems with the publication, do not hesitate to contact us by phone or by email",
        "bestregards": "Best regards,",
        "brief": "You will find the brief here",
        "content_size": "The content to be written is of",
        "hi": "Hi",
        "nextlevelteam": "the NextLevel team",
        "order_summary": "Order summary",
        "planneddate": "Wanted publication date",
        "pleasesdontpublishbefore": "Please don't publish before this date",
        "publishbefore": "Please publish the corresponding content before the",
        "redaction_you": "You are in charge of writing",
        "redaction_us": "We will take care of the writing",
        "redaction_us_quick": "We will do the writing and send you the content as quickly as possible",
        "seeyousoon": "See you soon on Nextlevel.link",
        "thanksreactivity": "Thanks in advance for your reactivity",
        "validate": "Once the content and the link are uploaded online, please validate it here",
        "subjects": {
            "orders": {
                "pending": "NextLevel : your order #{orderId} is pending acceptance",
                "pendingBis": "NextLevel : your order #{orderId} is still pending acceptance",
                "pending2ndReminder": "NextLevel : 2nd reminder, please indicate your agreement or refusal for your partner order #{orderId}",
                "pending3rdReminder": "NextLevel : Last reminder for your order #{orderId}, we are waiting for your news in urgency",
                "publishReminder": "NextLevel: you are approaching the publication deadline for your order #{orderId}",
                "publishLastReminder": "NextLevel : end of today's publication deadline for your order #{orderId}",
                "programmedPublishReminder": "NextLevel : reminder, you have a scheduled publication to fulfill within 2 days for your order #{orderId}",
                "programmedPublishToday": "NextLevel : Today you have to publish your partner order #{orderId}",
                "refus": {
                    "hs": "Your website is offline : it contains a valid NextLevel order (ref #{orderId})",
                    "outboundLinkProblem": "Outbound link problem has appeared on your current #{orderId} order.",
                    "numberOfWordsProblem": "Problem with the number of words added on your current #{orderId} order.",
                    "linkUndetected": "Problem on your current #{orderId} order, the link is not detected.",
                    "orderUpdated": "Problem of a newly appeared modification on your current #{orderId} order."
                }
            },
            "oubli": "Forgotten password",
            "newOpportunity": "New opportunities on NextLevel.link",
            "alert": "Your website corresponds to a customer need on NextLevel - Alert {numAlert}",
            "register": "Welcome on Nextlevel.link",
            "neworder": "New NextLevel order",
            "neworderpartner": "Partner: New NextLevel order (ref #{orderId})",
            "activation": "Activation of your website on Nextlevel.link",
            "newparnersite": "New partner website on Nextlevel.link",
            "newcontent": "NextLevel content available (order ref #{orderId})",
            "contentpublished": "NextLevel content published (order ref #{orderId})",
            "whidrawaldemand": "Receipt of your NextLevel withdrawal request",
            "gainsdemand": "Request of earnings withdrawal",
            "receptionask": "Receipt of your NextLevel withdrawal request",
            "validateask": "Validation of your NextLevel withdrawal request",
            "yourorder": "Your order #{orderId} for the keyword : {keyword} has been refused on Nextlevel.link !",
            "refused": "has been refused on Nextlevel.link",
            "acceptedbypartner": "The partner has accepted the order #{orderId})",
            "newdemand": "New fully-managed campaign request",
            "modifactiondemand": "Modification of the campaign request",
            "buyexactkeyword": "Purchase of the exact keyword of a pre-order",
            "preorderagain": "Continuation of the pre-order",
            "stoppreoder": "Cancelation of the pre-order for the keyword",
            "preorderavailable": "Your pre-order is available",
            "buycredit": "Purchase of credits by bank transfer",
            "deleteask": "Account suppression request",
            "addcredit": "Add credits for one of your fully-managed campaigns"
        },
        "activation-site-partenaire": {
            "validation": "One of your websites has just been validated on Nextlevel.link ",
            "validationtime": "Several minutes are necessary before displaying the number of keywords present in the NextLevel tool (urls without external outbound links with top 90 keywords in Google)",
            "list": "You can check the list of your website on this screen"
        },
        "alerte": {
            "followup": "Following your e-mail alert request on",
            "keyword": "the keyword",
            "keywords": "the keywords",
            "nbposition": "Number of positions",
            "top10": "Top 10",
            "opportunities": "here are the opportunities",
            "link": "To add/suppress or get more relevant alerts, you can change your filters on",
            "creationtool": "the alert creation tool"
        },
        "alerte-partenaire": {
            "interest": "We are sending you this email because you have expressed interest in receiving an alert",
            "alertcustomer": "when one of our customers express a need on NextLevel",
            "content": "One or more customers have a specific need and your website",
            "idealsite": "would be the ideal place for them",
            "submitarticle": "We invite you to view, write and submit the url of the article here",
            "articledonealert": "so that the customer can be alerted once positioned",
            "newkeyword": "Here are the new keywords you can write about",
            "dateoffer": "Date of the request",
            "otherpartner": "Other interested partners",
            "description": "Please keep in mind that when a custommer ask for the keyword \"repair iphone\", in the vast majority of cases you can get a position way faster by positioning your article on \"repair iphone that fell in water\" for example. Custommer also get a notification when a non-exact keyword is available on NextLevel",
            "alertssetup": "To add/suppress or get more relevant alerts, you can change your filtrers on",
            "partneralert": "partner alerts"
        },
        "commande-acceptee": {
            "partner": "The partner",
            "partner_02": "the partner",
            "partneraccept": "has accepted the order",
            "redaction": "Writing by"
        },
        "commande-refusee": {
            "content": "You have chosen to put a link on a NextLevel partner's website on the",
            "detail": "whose details are here",
            "explanation": "The partner has refused the link for the following reason",
            "explanation_01": "The given editorial line does not suit the partner",
            "explanation_02": "They believe that your request and their page are competing. In order to limit the risk of refusal for your next orders, we have blocked this website from the search results of your project"
        },
        "commande-terminee": {
            "content": "Your link has been posted, you can check it on your dashboard",
            "content_01": "To log in",
            "content_02": "Step to the next level"
        },
        "information-partenaire-supression-precommande": {
            "interest": "You expressed your interest for the pre-order",
            "nopreorder": "We are sorry to inform you that the customer, after having found his need on another website, does not wish to maintain his demand for future orders"
        },
        "notification-contenu-partenaire": {
            "content": "Hello, the content we have written for your page",
            "order": "order",
            "available": "is now available",
            "link": "The content and details of the order is available on the platform at the following address",
            "plugin-information-1": "To save time on your next orders: install the",
            "plugin-information-link": "NextLevel plugin",
            "plugin-information-2": "and your orders will be published on your website automatically after acceptance."
        },
        "notification-publication-via-plugin-partenaire": {
            "content": "Hello, the content we have written for your page",
            "nowpublished": "is now published",
            "ordersummary": "The summary of this order is available on the platform at the following address",
            "gains": "You earnings are now available on your partner account",
            "engagement": "We remind you that you are committed for a period of 24 monthss"
        },
        "nouvelle-commande": {
            "newlink": "A new link has been bought on Nextlevel.link",
            "user": "User",
            "mainkeyword": "Main keyword",
            "secondarykeyword": "Secondary keywords",
            "publishdate": "Publication date",
            "secondlink": "Second link",
            "secondanchor": "Second anchor text",
            "content": "Content",
            "brief": "Brief",
            "warning": "Warning: this website is a partner's website. The partner",
            "mail": "has just been notified by email",
            "copywriting": "He is in charge of the writing.",
            "copywriting_you": "Once the content is written, please communicate it"
        },
        "precommande": {
            "infos": "You have placed a pre-order on the keyword",
            "results": "one or more results are available here"
        },
        "api-documentation": {
            "title": "API Documentation"
        },
        "relance": {
            "hi": "Hi {firstname}",
            "creationaccount": "You have just created an account on",
            "addcredit": "but you have not yet added credits. Let us help you understand how to get the most of your NextLevel experience",
            "showdatas": "More data visible with credit",
            "withoutcredit": " Without credit, you don't get access to all the data needed to buy a backlink. Once you have added 100€ of credit (minimum), you will able to see more: positioned keywords, number of top 10 Google positions for a specific article...",
            "paypalnotneeded": "No need to create a Paypal account",
            "paypaldescription": "If it's Paypal that's turning you off, no worries. You can add credit to the tool without having to create an account, Paypal simply acts as an intermediary to secure online payment data. To credit your account without going through it, don't hesitate to contact our accounting department",
            "discoverkeywords": "Discover all your keywords in one click",
            "relevantkeywords": " To easily find the most relevant keywords available, you can synchronize your Google Search Console with the positioned articles. NextLevel will show you all the potential backlinks to your theme",
            "efficacy": "Efficient and practical",
            "proofs": "Finally, do you still feel the need for proof of the tool's effectiveness?",
            "testimonials": "Read the testimonials",
            "successtestimonials": "of those who have seen their position rising in a very short period of time",
            "questions": "Got some questions? Don't hesitate to ask. We are open to suggestions and above all, we try to offer a practical and operational tool. You can get in touch with us by phone, social medias or email.",
            "dontwait": "Don't wait any longer to",
            "tocredit": "credit your account",
            "waitingforyou": "and start ranking, we are waiting for you",
            "linknotshowingup": "If the link does not appear, paste this URL into your browser"
        },
        "relance-acceptation-partenaire-1": {
            "infos": "Dear partner, it has been 3 days since you got an order for the website"
        },
        "relance-acceptation-partenaire-2": {
            "infos": "Dear partner, it has been 6 days since you got an order for the website"
        },
        "relance-acceptation-partenaire-3": {
            "infos": "Dear partner, it has been 9 days since you got an order for the website",
            "answerneeded": "You still haven't accepted or refused the order. The maximum delay for publication being 10 days, we recommend that you answer as quickly as possible",
            "declineorder": "Without a answer from you, we will have to refuse the order"
        },
        "relance-acceptation-partenaire-info-client": {
            "info": "You placed an order on our platform that have been waiting for the approval of the partner for 5 days. We are tracking the evolution of this order, and we have already send a follow-up email to our partner in order to obtain an answer as quickly as possible",
            "orderstatus": "Please note that you can see the status of this order from your dashboard: from acceptance by the partner to validation"
        },
        "relance-publication-partenaire-1": {
            "content": "Dear partner, you accepted an order placed 8 days ago. Our deadline being 8 working days, which is approximately 10 calendar days, we recommend that you publish your article quickly.",
            "redaction_you": "You are in charge of the writing",
            "redaction_us": "We are in charge of the writing"
        },
        "relance-publication-partenaire-2": {
            "content": "Dear partner, the deadline for publishing your order is coming close to an end. Please publish it as soon as possible and validate it on NextLevel once it's done",
            "assist": "If you are encoutering troubles with the order, please contact us without delay so that we can inform the customer",
            "assist_contact": "Either by phone or email",
            "skype": "Or by skype"
        },
        "relance-publication-partenaire-3": {
            "deadline": "Dear partner, you accepted an order for which a specific date of publication has been requested. We are simply reminding you that you will have to publish this order in two days"
        },
        "relance-publication-partenaire-4": {
            "deadline": "Dear partner, you accepted an order with a precise date of publication. This date is today",
            "publishtoday": "Please publish and validate the order today."
        }
    },
    "factures": {
        "amounHT": "Amount HT",
        "amounTTC": "Amount",
        "amountTTC": "Amount (excluding VAT)",
        "date": "Date of the order",
        "invoice": "Invoice",
        "quotation": "Quotation",
        "numberInvoice": "You have {n} invoice(s)",
        "title": "My invoices",
        "noordersyet": "No purchase has been made on Nextlevel.link",
        "notAvailable": "Not available",
        "orderType": "Type"
    },
    "favorites": {
        "allsites": "All the websites",
        "excludedtheme": "Theme to exclude",
        "nextlevel": {
            "title": "NextLevel gold nuggets",
            "nofav": "No NextLevel favorites yet."
        },
        "noadultfilter": "Display adult results",
        "nofavyet": "You have not saved any favorites yet.",
        "none": "None",
        "partners": "Partners",
        "min": "Minimum",
        "title": "Favorites",
        "top": "Top",
        "topten": "Number of top 10"
    },
    "partnerAdmin": {
        "actions": {
            "displayCommercialProfil": "View Commercial Profile",
            "validate": "Validate partner",
            "invalidate": "Invalidate partner",
            "modifyProfile": "Modify profile",
            "saveProfile": "Save modifications"
        },
        "status": {
            "label": "Partner Status",
            "validate": "Validate",
            "invalidate": "Invalidate",
            "undefined": "Undefined"
        },
        "attestation": {
            "label": "Attestations",
            "with": "With attestation",
            "without": "Without attestation",
            "validatePopup": {
                "title": "Définir une date d'échéance",
                "label": "Saisir une date d'expiration pour l'attestation"
            },
            "urssafPopup": {
                "title": "Validation automatique URSSAF",
                "label": "Saisir le code de sécurité l'attestation"
            },
            "refusePopup": {
                "title": "Refuser l'attestation",
                "label": "Saisir la raison du refus",
                "comment": "Commentaire"
            },
            "refuseReasons": {
                "olderThan6Month": "Attestation de plus de 6 mois",
                "impossibleToValidate": "Impossible à valider URSSAF",
                "cantRead": "Illisible",
                "urssafMandatory": "URSSAF obligatoire",
                "other": "Autres (champs libres)"
            },
            "actions": {
                "validate": "Validate",
                "cancel": "Cancel",
                "delete": "Delete",
                "refuse": "Refuse"
            },
            "status": {
                "new": "New",
                "validate": "Validated",
                "expired": "Expired",
                "refused": "Refusée"
            }
        },
        "subscriptionDate": "Subscription",
        "user": "Login",
        "withdraw": "Withdraw Total"
    },
    "filtres-liens": {
        "filter": "You have the possibility to filter the search results (ex: removing the websites you already have backlinks on)",
        "filterbykeyword": "Filter by keyword",
        "filterbytheme": "Filter by theme",
        "filterotherlinks": "Filter my other links",
        "filterdescription": "Filters can be golbal or by projet. Write down the domain name of the websites that you wish to hide from search (one per line)",
        "filterglobal": "Global filter",
        "filteroftheproject": "Project filter",
        "update": "Your filters have been updated!"
    },
    "layout": {
        "addkeyword": "Add keywords",
        "advice": "Need some advice? Contact us:",
        "advisor": "Consultant",
        "alerts": "My alerts",
        "alertscustommerneeds": "Customer needs Alerts",
        "availablesites": "Available websites by users",
        "cgv_full": "Terms and conditions",
        "cgv": "GTC - GCS",
        "cgv_mobile": "GTC for clients",
        "cgvpartners": "GTC for partners",
        "cgvpartners_mobile": "GTC for partners",
        "clickhereaccount": "Click here to get back to your account",
        "clickhereconseils": "Click here to get back to campaigns",
        "clickhereaccompagnement": "Click here to get back to campaigns consultant",
        "clientaccount": "Beware, you are logged in with a customer account",
        "config": "Configuration",
        "configmails": "Mail configuration",
        "contact": "Contact",
        "counseilling": "Campaigns",
        "custommers": "Customers",
        "customerneeds": "Customers' needs",
        "dashboard": "Dashboard",
        "emailsales": "Commercial Email",
        "emailsupport": "Help Desk Email",
        "faqcustommers": "Customers FAQ",
        "faqpartners": "Partners FAQ",
        "gains": "Earnings",
        "getcouseilling": "Delegate my campaign(s)",
        "invoicessummary": "Orders summary",
        "keywords": "Keywords",
        "launch-credit": "Trigger Credit",
        "launch-invoice": "Trigger Invoice",
        "launch-wait": "Trigger Awaiting",
        "lastsearch": "Latest searches",
        "lastglobalsearch": "Latest global searches",
        "markasread": "Mark as read",
        "markallasread": "Mark everything as read",
        "myagency": "Agency",
        "mycounseillors": "My agency",
        "nosearchyet": "You have not made any search",
        "partners": "Help Desk / Partners",
        "payments": "Payments",
        "phonecustommer": "Customer Phone",
        "phonepartner": "Partners Phone / Help Desk",
        "preorder": "Pre-order",
        "preorders": "Pre-orders",
        "profil": "My profile",
        "promocode": "Promo Code ",
        "promourl": "Get 50% of all urls on NextLevel bronze and silver websites, enjoy it until Monday 11:59pm!",
        "researchdomain": "By domain",
        "researchkeyword": "By keyword",
        "researchkeywordlist": "By keyword list",
        "researchtheme": "By theme",
        "researchurl": "By page",
        "seeallthesearch": "Show all the searches",
        "seeallnotifications": "Show all the notifications",
        "seedatas": "To see all the data, please ",
        "seedatascredits": "credit your account",
        "tracking": "Tracking",
        "selling-websites": "Buy websites",
        "transfer": "Transfer",
        "billing": "Facturation",
        "urlsummary": "Suggested URLS Summary",
        "users": "Users",
        "user-attestation": "User's attestation",
        "partner-admin": "Partners",
        "whidraw": "Withdrawal",
        "validateProfile": "Please update your personal information and billing address before any withdrawal",
        "netlinkingplatform": "Netlinkink Platform",
        "coupon-management": "Coupon Management",
        "last-researches": "Last searches",
        "not-found": "The page you are looking for does not exist",
        "not-found-title": "Oops ...",
        "unauthorized": "This page is not authorized",
        "unauthorized-title": "Hum ..."
    },
    "login": {
        "username": "Email address",
        "password": "Password",
        "connexion": "Login",
        "forgotten_password": "Forgotten password?",
        "notyetregister": "Not registered yet?",
        "or": "or",
        "register": "Register",
        "error": "Error while logging in!",
        "userOrPasswordFailed": "Incorrect username or password."
    },
    "mes-accompagnements": {
        "ambition": "Ambition",
        "alreadydone": "Already done",
        "ask": "Fully-managed campaign request",
        "asksent": "Your campaign request has been sent!",
        "brief": "Your brief",
        "budget": "Monthly Budget",
        "budgetglobal": "Total Budget ",
        "budgetspend": "Budget spent",
        "budgeturl": "Monthly budget by URL",
        "clientbrief": "Customer Brief",
        "datestart": "Start date",
        "dateend": "End date",
        "details": "Campaign details",
        "duration": "Campaign duration",
        "gettheposition": "Get the position",
        "help-no": "I don't want to delegate my netlinking for free",
        "help-yes": "I want to delegate my netlinking for free",
        "invoices": "Pay my campaign(s) bills",
        "invoicegeneration": "Invoice has been generated",
        "invoicegenerationfailed": "Invoice hasn't been generated properly. Please contact the Help Desk",
        "keywordstoadd": "Add a keyword / page to work on",
        "keywordstoworkon": "Keywords and pages to work on",
        "keywordfrompage": "Keywords of the page",
        "lastposition": "Last position",
        "lastposition-alt": "Last Pos.",
        "manualposition": "1st manual Position ",
        "manualposition-alt": "1st Pos.",
        "min-budget": "Please note that free support cannot start at less than 500€/month or 1500€",
        "noorder": "No order for this month",
        "opti": "Optimized",
        "optihalf": "Half-optimized",
        "positioninit": "Initial position",
        "request": "Requests",
        "seeorders": "See orders",
        "sitecategory": "Website category",
        "supportdatestart": "Starting date of the campaign",
        "supportdateend": "End date of the campaign",
        "supportsave": "Save the campaign settings",
        "supportlaunch": "Launch the campaign",
        "time": "Duration (months)",
        "title": "My fully-managed campaigns ",
        "todefine": "To be defined",
        "toworkon": "To work on",
        "urltopush": "Target URL",
        "url": "Purchased URL",
        "variation": "Variation",
        "variation-alt": "Var.",
        "workonpage": "Page to work on",
        "waitingcredit": "Awaiting credits"
    },
    "mes-credits": {
        "balancebefore": "Balance before",
        "balanceafter": "Balance after",
        "buycredits": "Buy credits",
        "credits": "Credits",
        "title": "Credits",
        "myorder": "My Order"
    },
    "next-level": {
        "anchorimg": "Anchors on images",
        "anchors": "Generic anchors",
        "confirm": "Are you sure?",
        "cancelsearch": "Cancel my search",
        "exactsearch": "Exact search",
        "externallink": "External Link",
        "filtersless": " Less filters",
        "filtersmore": " More filters",
        "keywordimg": "Picture keywords",
        "mailsent": "Email sent",
        "newpartners": "Many partners are added every day on NextLevel: set up an alert to know when an article is positioned on",
        "noarticle": "None of the articles on NextLevel are positioned on this keyword",
        "nodiscount": "No discounted result on this request",
        "noworries": "No worries",
        "preorder": "Place a pre-order to try to get an article positioned on your keyword",
        "preorderfree": "Pre-order articles FOR FREE",
        "optimizedkeyword": "Optimized keywords",
        "optimizedanchors": "Optimized anchors",
        "recommandation": "We recommend you",
        "recommandation_02": "either to search for other keywords related to the theme - and not only your exact keyword",
        "recommandation_03": "either to search by keyword, but not only on the discounted ones, in order to find more results",
        "searchkeyword": "Search by keyword",
        "searchmoresimple": "Try a simpler search, for example",
        "track": "We're not tracking this keyword yet",
        "twopossibility": "You have two possibilities",
        "typekeyword": "Type a keyword",
        "requestnewtry": "Also try the following requests",
        "wait": "Wait a moment, we'll add it to our database"
    },
    "notifications": {
        "deleteall": "Delete all",
        "learnmore": "Learn more",
        "nonotifications": "You don't have notifications",
        "title": "Notifications",
        "date": "Date",
        "titre": "Title",
        "message": "Message",
        "read": "Read",
        "unread": "Unread",
        "state": "State"
    },
    "oubli": {
        "title": "Forgotten password",
        "username": "Username",
        "resetPassword": "Change my password",
        "resetConfirmationTitle": "Success",
        "resetConfirmationMessage": "You will receive an email allowing you to reset your password.",
        "resetFailed": "This username does not exist.",
        "backToLogin": "Back to login"
    },
    "oubli-etape-2": {
        "title": "Change your password",
        "passwordChangedTitle": "Success",
        "passwordChangedMessage": "Your password has been successfully updated. You can now login",
        "invalidLink": "This link doesn't exist.",
        "userNotExists": "This user does not exist",
        "newPassword": "New password",
        "newPasswordConfirmation": "Confirm new password",
        "changePasswordAction": "Reset your password",
        "linkToLogin": "<a href=\"login_en.php\"> by clinking here</a>",
        "passwordChangedError": "There was an error during the password modification. Please check the requirements"
    },
    "precommande": {
        "reference": {
            "long": "Référence",
            "short": "Ref."
        },
        "add": "Add a pre-order",
        "all": "All",
        "aboutkeyword": "About your order on the keyword ",
        "cancelpreorder": "Cancel pre-order",
        "cancelpreorders": "Cancel {length} pre-orders",
        "changeproject": "Move order into project",
        "changeprojects": "Move {length} orders into project",
        "columns": {
            "locale": "Language",
            "keyword": "Keyword",
            "keywordplaceholder": "Search by keyword",
            "secondarykeyword": "Secondary keywords",
            "secondarykeywordplaceholder": "Search by secondary keyword",
            "brief": "Brief",
            "briefplaceholder": "Search by brief",
            "nbArticle": "Number of desired articles",
            "project": "Project",
            "createdat": "Created on",
            "createdatplaceholder": "Search by date",
            "expires": "Expires"
        },
        "date": "Order date",
        "list": "List of my pre-orders",
        "neworder": "Do you wish to maintain this pre-order and try to get new positioned articles or is your need already fulfilled?",
        "neworderkeyword": "Do you wish to maintain this pre-order and try to get new positioned articles on the exact keyword, or is your need already fulfilled?",
        "otherordersyes": "Yes, I want to place other orders on this keyword: I want to keep my pre-order ",
        "otherordersno": "No, I don't want this pre-order anymore. I will place an other pre-order on the same keyword later if I want to",
        "placeorder": "You ordered an URL positioned on the keyword  « ",
        "placedorderalready": " » for which you made a pre-order",
        "placedurl": "We have postioned an URL on this non-exact keyword, to match your pre-order on the keyword «",
        "redactionongoing": "In writing",
        "restartorder": "Renew {length} pre-order",
        "restartorders": "Renew {length} pre-orders",
        "status": {
            "encours": "In progress",
            "expiree": "Expired",
            "stopped": "Stopped",
            "todo": "To do",
            "inprogress": "In writing",
            "awaiting": "Awaiting positioning",
            "done": "Done",
            "all": "All"
        },
        "validate": "Save",
        "waintingposition": "Awaiting positioning"
    },
    "partenaire-commandes-detail": {
        "title": "Details for the order"
    },
    "partenaire-commandes": {
        "title": "My orders",
        "export": "Export to CSV",
        "terminate-error": "Completed containing errors",
        "publication_date": "Publication date",
        "orderlist": {
            "all": "All orders",
            "toaccept": "Orders to be accepted",
            "todealwith": "Orders to be completed",
            "finished": "Completed orders",
            "finishederror": "Completed orders containing errors",
            "denied": "Canceled / Refused orders "
        },
        "sending-date": "Sending date",
        "error": {
            "noorder": "You haven't placed an order yet",
            "validate": "No orders to validate",
            "manage": "No orders to complete",
            "finished": "No completed orders.",
            "finish+error": "No completed orders containing errors",
            "refused": "You haven't refused an order yet"
        },
        "cancel": {
            "title": "Order refusal",
            "reason": "Reason of refusal",
            "concurrent": "It's a direct rival",
            "hs": "Order is off-topic regarding the subject of the article",
            "error": "I made a mistake, I didn't want to put this URL for sale",
            "price": "Price doesn't suit me",
            "details": "Please specify the reason of refusal (min. 10 characters)."
        },
        "gain700": "You have reached 700 euros of earnings on NextLevel",
        "minigain": "Minimum desired earnings for the URL*",
        "minigainsite": "Minimum desired earnings for the whole website.",
        "gainwarning": "Warning: setting a minimum earnings that is too high may strongly reduce the orders you get.",
        "plannedorder": "This order is planned, you can't publish it too early.",
        "refuseorder": "Refuse the order",
        "refresh": "Once you have restarted the verification, please refresh the page",
        "extlinks": "Presence of external links",
        "seedetails": "See the details",
        "acceptorder": "I accept the order",
        "Irefuseorder": "I refuse the order",
        "acceptorders": "I accept the orders",
        "Irefuseorders": "I refuse the orders",
        "wantedpublication": "Wanted publication",
        "gains": "Earnings after publication",
        "wordsyou": "words to be written by you",
        "wordnextlevel": "words to be written by NextLevel",
        "wordsnextlevelongoing": "words currently being written by  NextLevel",
        "contentredaction": "Content currently being written by NextLevel",
        "contentredactionwaiting": "Content will be written when the order will be accepted",
        "seecontent": "See the content",
        "see-error": "See errors",
        "relancecheck": "Restart verification",
        "redactionNL": "Delegate the writing to NextLevel (free)",
        "acceptredactionNL": "Accept order and delegate the writing to NextLevel (free)",
        "published": "I have published",
        "pending": "Pending",
        "response-code": "Response code",
        "valid-edit-orders": "Orders has been edited",
        "valid-edit-order": "Order has been edited",
        "invalid-edit-orders": "Orders cannot be edited",
        "invalid-edit-order": "Order cannot be edited",
        "verify-date": "Please verify wanted publication date",
        "confirm-accept": "By continuing you confirm to accept the following orders",
        "confirm-refuse": "By continuing you confirm to refuse the following orders",
        "confirm-publish": "By continuing you confirm that you have published the following orders",
        "published-orders": "Published orders",
        "external-links": "External links",
        "first-link": "First link / First anchor",
        "second-link": "Second link / Second anchor",
        "test-word-count": "Word count test",
        "refresh-only": "Refresh the page",
        "choose-format": "Please choose a format to export files",
        "get-data": "Get data",
        "back": "Back to orders",
        "found-errors": "Errors were found on your orders",
        "orderdetail": {
            "title": "Details of the order ",
            "nofoundorder": "The order has not been found.",
            "publishdate": "Wanted publication date: ",
            "publishdatethanks": "Please don't publish before this date.",
            "addurl": "Please add this order on the requested page of your website, then validate it in your order list"
        }
    },
    "partenaire-gains": {
        "title": "My gains",
        "cgvknowledge": "I certify that I have read the Terms and Conditions. Reminder: gains cannot be withdrawn and must be used exclusively within NextLevel ",
        "current-gain": "Current gains : ",
        "event": "Event",
        "amount": "Amount",
        "nogainsyet": "You don't have gains yet.",
        "picktheamount": "Pick the amout : turn your gains into credits and you will automatically be gifted {bonus}% credits.",
        "transform": "Turn your gains into credits",
        "amounttransform": "Amount to transform",
        "gift": "Gifted credits",
        "withdrawfundsdone": "You already have a withdrawal planned this month. Please try again next month",
        "withdrawfunds": "Withdraw my gains ",
        "amounttowithdraw": "Amount to withdraw ",
        "errororder": "You have one or several orders containing errors.",
        "correct": " Please correct ",
        "yourerrors": "your errors here",
        "errortransfer": "in order to allow the withdrawal/transfer of your earnings",
        "limit": "Reminder: withdrawals are limited to {maxCeilingWithdrawal} euros. If you withdraw your earnings, an invoice will be edited.",
        "minWithdrawalWarning": "Your winnings are below the withdrawal floor of {minWithdrawal} euros.",
        "attestation": "Please upload an fiscal attestation on your profile page",
        "preferedinvoicing": "Billing preference",
        "generate": "I generate an invoice online (your company must be in France)",
        "mail": "I send my invoice by email",
        "invoicenumber": "Desired invoice number",
        "invoicemail": "If you choose to edit your invoice yourself, contact details and billing information will be sent to you by email",
        "exact": "I certify the accuracy of the information provided and",
        "cgv": "that I have read the Terms and Conditions.",
        "honor": "I confirm that I have not made another withdrawal request this month (after verification of your current orders by our team, the payment will be made within 30 days)",
        "honorgain": "I hereby certify that I know that any amount over 600 euros per year must be reported on the income tax return.",
        "amountmin": "The amount must be superior to ",
        "maxamount": "The amount is higher than your earnings or than the maximum amount allowed"
    },
    "partenaire-site": {
        "order-auto": "Auto. orders",
        "preorder-auto": "Auto. preorders",
        "order-preorder-auto": "Auto. orders / Auto. preorders (Plugin required)",
        "manage-auto": "Manage",
        "after-sale": "after sale",
        "accept-auto": "Automatic orders",
        "accept-auto-preorder": "Automatic preorders",
        "accept-auto-preorders": "Accept automatically preorders",
        "accept-auto-info": "Orders corresponding to your criteria will be automatically accepted, you will not have to do it manually",
        "accept-auto-info-preorder": "Publication of preorders on your site in relation to a Nextlevel requirement.",
        "accept-auto-orders": "I wish, for the selected sites, that the orders are accepted automatically",
        "addcontent": "If adding too much content on your articles bothers you, you can limit it here",
        "addlink": "You must add each ordered link within 10 days",
        "addawebsite": "Add a website",
        "download_wp_plugin": "Download the Wordpress plugin",
        "avancedmodedescription": "With this mode, you can refine the list of URLs for sale through the use of sitemaps, and/or a whitelist, and/or a blacklist",
        "advancedoptions": "Advanced options",
        "all-no-url": "All except URL",
        "allowplanning": "Allow the customer to plan the link publication",
        "alreadybought": "You already bought a link on this domain.",
        "alltheanchors": "All the anchors (recommended option)",
        "all-site": "All site",
        "anchors": "Anchors allowed",
        "avancedmode": "Advanced mode: I only validate a part of the website",
        "attenteamelioration": "Waiting for improvement",
        "back": "Back to websites",
        "blacklist-textfile": "Blacklist via text file",
        "blacklisturl": "URLs defined in the blacklist. Click here to remove them",
        "blacklist-groups-info": "You can determine which topics you do not want links",
        "blacklist-groups-label": "Define rejected topics",
        "blacklist-groups-add": "Add a topic",
        "cgv": "the Terms and Conditions*",
        "choice": "Choice",
        "cmstype": "CMS type",
        "confirm": "I confirm that I want to buy another link for this domain on this website.",
        "confirmsupress": "Are you sure you want to delete your website?",
        "deletesite": "Delete my website",
        "deletesites": "Delete my websites",
        "deactivateddNextLevel": "Website deactivated by NextLevel. Please contact the help desk fore more information",
        "deactivatedtemp": "Temporarily deactivated by yourself",
        "desactivation": {
            "titre": "{ndd} has been desactivated",
            "titre-temp": "{ndd} has been temporarily desactivated",
            "message": "The website {ndd} of {usernameNL} has been desactivated on Nextlevel.link.",
            "message-temp": "The website {ndd} of {usernameNL} has been desactivated on Nextlevel.link. Reactivation date: {dateEnd}"
        },
        "amelioration-site": {
            "modifs": {
                "rd": "Bonjour, nous apprécions votre demande de partenariat sur NextLevel. Votre site ne remplit pas encore tous nos critères de qualité. Nous gardons votre site en attente, il sera accepté dès qu'il présentera plus de 20 domaines référents.",
                "content": "Bonjour, nous apprécions votre demande de partenariat sur NextLevel. Votre site ne possède pas assez de mots-clés. N'hésitez pas à créer de nouveaux contenus afin que nous puissions valider votre site. Nous revérifierons cet aspect dans les semaines à venir.",
                "links": "Bonjour, nous apprécions votre demande de partenariat sur NextLevel. Votre site dispose de trop de liens sortants au sein des contenus ce qui lui empêche d'avoir des pages en vente sur Nextlevel. Nous revérifierons cet aspect dans les semaines à venir.",
                "design": "Bonjour, nous apprécions votre demande de partenariat sur NextLevel. Cependant nous mettons votre site en demande d’améliorations pour le design. Merci de mettre un design plus dynamique et imagé. Nous vous encourageons aussi à intégrer un favicon. Nous revérifierons votre site dans les prochains jours.",
                "onepage": "Bonjour, nous apprécions votre demande de partenariat sur NextLevel.  Nous mettons votre site en attente car c'est un one page. Merci d'ajouter des catégories et nous revérifierons cet aspect dans les semaines à venir."
            }
        },
        "deactivationfrom": "Deactivated from ",
        "deactivateduntil": "Deactivated until ",
        "desactivationwebsite": "Deactivation of my website",
        "desactivationwebsites": "Deactivation of my websites",
        "desactivationtemporary": "Temporary Deactivation",
        "desactivationwithoutdate": "Deactivation without date",
        "disapointed": "I'm disappointed by the price of the links",
        "dontownthesite": "I don't own the website anymore",
        "dontapprouve": "I do not approve the principle of selling on existing URLs",
        "enddate": "Resumption date",
        "engagement": "You agree to maintain the links 24 months",
        "engagementmonths": "I remain committed for 24 months as indicated in",
        "externallinks": "Only the pages without external links are eligible",
        "generics": "Generics (click here, to learn more, etc) only",
        "get_generic_anchor": "Get random generic anchor",
        "get_random_anchor": "Get random anchor from keywords",
        "humanvalidation": "Each website is manually validated by a member of our team",
        "site-owner": "Reminder : you must be the owner of the website",
        "keywords": "Keywords",
        "urls": "URLs",
        "keywords-choice": "Keywords in a sentence only",
        "no-keywords": "No keywords related to this domain",
        "mainurl": "Main URL, with http(s)://",
        "maxcontent": "Maximum content allowed per article",
        "MFAconcurrent": "Refusal: rival",
        "minigain": "Minimum earnings (we recommend that you leave it empty at first)",
        "minigainexplanation": "The minimum earnings is the amount below which the URL will not be listed for sale. Please type the minimum earnings here (it's not the price but your earnings).",
        "motif": "Please indicate a reason",
        "nositeactivated": "No activated websites",
        "nositedesactivated": "No deactivated websites",
        "nowebsitesawaiting": "No websites waiting for validation",
        "nositeyet": "No websites yet",
        "norefused": "No denied websites",
        "nodeletedsite": "No deleted websites",
        "now": "Now",
        "no-recommandation": "No (recommended option)",
        "othercms": "Other CMS",
        "others": "Other, please specify ",
        "orders": {
            "title": "Domain orders",
            "no-orders": "No orders related to this domain"
        },
        "partner": "Partner",
        "reactivationwebsites": "Reactivation of my websites",
        "reactivationwebsite": "Reactivation of my website",
        "reactivationwebsite-text": "Confirm you want to reactivate your site",
        "reactivationwebsites-text": "Confirm you want to reactivate your sites",
        "redaction": "Writing",
        "redactionmyself": "I will write the additional texts myself",
        "redactionnextlevel": "I leave the writing to the NextLevel team",
        "wordpress_plugin": "Wordpress plugin",
        "wordpress_plugin_settings": "Wordpress plugin settings",
        "wordpress_plugin_tooltip": "Plugin version | Wordpress version",
        "secondarylink": "Secondary link allowed",
        "secondarylink-info": "The customer can ask for a second link if he wants, increasing the price of the link and therefore the remuneration of the partner",
        "seekeywords": "Show the keywords",
        "selecttxt": "Select a .txt file with the relevant URLs",
        "simplemode": "Simple mode: I validate all the website",
        "soldlinks": "for the sold links",
        "startdate": "Start date",
        "supress": {
            "titre": "{ndd} has been deleted",
            "message": "The website {ndd} of {usernameNL} has been deleted from Nextlevel.link. Reason: {noteCustomer}"
        },
        "title": "My websites",
        "to": "to",
        "toomuchsales": "I've already sold too much on this website",
        "update": "(Ongoing update)",
        "url": "Involved URLs",
        "url-choice": "URL (mywebsite.com, https://www.mywebsite.com) only",
        "urlforsale": "URLs for sale",
        "urlsorgeneric": "URL or generic only",
        "urlsGenericKeywords": "URL, generic term or keywords included in a sentence or a string of words",
        "valid-save-site": "Your site has been added. It is awaiting validation",
        "valid-edit-site": "Your site has been modified",
        "valid-edit-sites": "Your sites has been modified",
        "valid-delete-site": "Your sites have been deleted",
        "valid-desactive-site": "Your sites have been deactivated",
        "valid-reactive-site": "Your sites have been reactivated",
        "valid-save-wp": "Wordpress plugin updated",
        "whitelist": "Whitelist via XML sitemaps: please enter the URLS, separated by a comma if necessary",
        "whitelist-textfile": "Whitelist via txt file",
        "whitelisturl": "URLs defined in the whitelist. Click here to remove them",
        "wordsrecommandation": "words (recommended option)",
        "yes-recommandation": "Yes (recommended option)"
    },
    "partenaire-mot-cles": {
        "backtosites": "Back to the websites",
        "blacklist": "Blacklist",
        "blacklistdescription": "When you blacklist an URL, its associated keywords will be removed from NextLevel and will no longer be available for purchase",
        "blacklistdescription_02": "You will still be able to allow orders on this URL later. To do this go the  \"URLs for sale\" section of your websites dashboard.",
        "blacklistURL": "Blacklist the URL",
        "infos": "The selling price is indicative and varies according to the performance of each URL and its keywords.",
        "keyword": "Keyword",
        "position": "Position",
        "volume": "Volume",
        "error": {
            "class": "Unsaleable page",
            "externalLinks": "External links",
            "notScrapped": "not scrapped",
            "price": "Minimum price",
            "scrap": "Scrap error"
        },
        "gainonurl": "Earnings for a link on this URL",
        "gain": "Earn",
        "globalSite": "Global - site",
        "global-min-gain-define": "Reset floor gains (Global - site)",
        "global-reset-desc": "Beware, all your floor earnings will be removed.",
        "isScrapped": "Scrapped",
        "potentialGain": "Potential total earn",
        "label": {
            "all": "All",
            "saleable": "Saleable",
            "unsaleable": "Unsaleable"
        },
        "mainkeyword": "Main keyword",
        "minigain": "Minimum earnings",
        "minigainAllURL": "If you want to set an overall minimum earnings for all existing and future URLs, go to",
        "minigainAllURL_02": "your websites dashboard",
        "minigainAllURL_03": "click on \"Actions > Edit\" and adjust the price in the advanced options",
        "minigainnotreached": "At the moment the earnings of the url defined by our algorithm doesn't reach the minimum earnings you set",
        "minigaindefine": "Set a minimum earnings",
        "nokeyword": "No keyword has been found",
        "reinit": "Reset",
        "reinitminigain": "Reset minimum earnings",
        "reinitminigaindescription": "Please confirm. If you reset this function, all of your setted up minimum earnings for the selected URLs will be erased",
        "reinitminigaindescription_02": "After that, all the selected URLs will be avaible for sale whatever the price defined by our algorithm. We ask you to accept a maximum of orders if you choose not to use the minumum earnings function.",
        "reinitminigainurl": "Reset the minimum earnings (URL)",
        "reinitminigainsite": "Reset the minimum earnings (Global - website)",
        "rescrap": "Restart the URL check",
        "saleablePage": "Saleable page",
        "totalgains": "Total earnings of all of the URLs for the website",
        "urlavailable": "Available URLs for sale",
        "urlnotavailabe": "URLs not available for sale",
        "visibility": "Visibility in search",
        "warning": "Warning, all your minimum earnings setings will be deleted",
        "alert-reinit-min-gain": "Gains successfully reset",
        "alert-reinit-min-gain-global": "Global gain successfully reset",
        "alert-blacklist-urls": "URLS successfully blacklisted",
        "alert-min-gain": "New gain registered",
        "no-more-keywords": "No more keywords indexed for this URL"
    },
    "partenaire-precommandes": {
        "article-number": "Need(s) for article(s)",
        "date": "Date of the request",
        "export": "Export",
        "group": "Group",
        "googleposition": "As soon as they get a position on Google, as detected by SEMrush, the customer is notified",
        "intro": "Each NextLevel customer can place a pre-order and indicate the keyword on which they would like to have a positioned article. When it happens, they get notified by e-mail, then free to place an order on the link, which happens in  90% of the cases.",
        "intropartner": "As a partner, you will have the opportunity to benefit from it.",
        "interest": "Keywords that interest me",
        "interest-considered": "Interest considered",
        "interestedredaction": "I'm interested in writing an article on this subject",
        "nointerest": "Keywords in which I have not yet expressed an interest",
        "nopreorder": "No pre-order is available.",
        "notinterestedredaction": "I'm no longer interested in writing an article on this subject.",
        "otherpartners": "Other interested partners",
        "price": "Price is defined by our algorithm, as for any other order.",
        "selectkeyword": "Select the keyword that interests you",
        "show-proposals": "See my proposals",
        "suggest": "Suggest an URL",
        "suggestother": "Suggest another URL",
        "redactionwebsite": "Write an article on your website",
        "redactors": "Other interested writers",
        "title": "Write articles on the most wanted keywords by our clients!",
        "url": "Suggested URL"
    },
    "profil": {
        "navbar": "Submenu :",
        "account": "My account",
        "tab": {
            "profil": "Profile",
            "address": "Address",
            "order": "Orders",
            "sponsorship": "Sponsorship",
            "external-api": "External APIs",
            "delete-account": "Delete my account",
            "personnal-data": "Personal data"
        },
        "profil": {
            "modify-password": "Modify my password"
        },
        "address": {
            "attestation": "Document à fournir",
            "attestation-detail": "(Attestation de vigilance URSAFF ou Extrait de KBIS ou certificat d'inscription Insee)",
            "submenu": "My business informations"
        },
        "delete": {
            "confirm": "I confirm the deletion of my account",
            "delete-account": "Delete my account",
            "submenu": "Management of my personal data"
        },
        "orders": {
            "add-receiver": "Add other recipients for orders (email)",
            "send-me-a-copy": "Send me a copy of orders",
            "orders": "Orders",
            "submenu": "Recipients of the orders"
        },
        "sponsorship": {
            "intro": "Earn 5% of the total orders made by your sponsored users",
            "url": "Your sponsorship URL",
            "compensation": "Sponsorship Reward",
            "credit": "Credits",
            "earn": "Earnings",
            "unused": "Nobody has used your sponsorship link yet.",
            "sponsee": "Sponsored party",
            "depot": "Deposit",
            "gains": "Earnings",
            "gains-totaux": "Total earnings",
            "sponsee-total": "Sponsored users"
        },
        "external-api": {
            "semrush": "SEMrush API Key"
        },
        "support": {
            "global": "Global",
            "pages": "Pages",
            "dont-forget-to-add-pages": "Don't forget to add pages you want to work on in \"Pages\".",
            "discuss-with-us-first": "If you prefer to discuss it first, feel free to leave it blank",
            "first-page-to-work-on": "First page to work on",
            "keywords": "Keywords for page 1",
            "anchors": "Anchors for page 1 (leave it blank if you want it to be managed by NextLevel)",
            "add-page": "Add a new page to work on",
            "send": "Send my campaign request",
            "modify": "Campaign modification"
        },
        "validation": {
            "front": {
                "siret": "Please check that your SIRET is composed of 14 digits without spaces.",
                "tva_number": "Please fill in your number without spaces.",
                "account-confirm-delete": "Please confirm that you wish to delete your account."
            },
            "back": {
                "email-already-in-use": "Sorry, this email address is already in use!",
                "email-invalid": "This email address is invalid",
                "password-too-short": "Password should be at least {limit} characters length.",
                "password-mismatch": "The password and the password confirmation are not identical.",
                "profil-updated": "Your profile has been successfully updated!",
                "order-updated": "Generic order information has been updated!",
                "key-updated": "Your key has been updated!",
                "support-contacted": "Your fully-managed campaign request has been sent!"
            }
        },
        "new-password": "New password (leave empty if you don't want to change it)",
        "confirm-new-password": "Confirmation of your new password",
        "language": "Language",
        "delete-account-confirmation": "Delete my account",
        "interface-language": "Interface language",
        "api-documentation": "Go to API documentation",
        "api-limit": "Limitations",
        "api-request-time": "Maximum requests per minute",
        "api-auth-login": "Get an API token",
        "api-partner-order": "Retrieve your order list",
        "api-partner-needs": "Retrieve the list of customer needs",
        "api-partner-sites": "Retrieve the list of sites",
        "api-partner-preorders": "Retrieve the list of preorders",
        "api-partner-groups": "Retrieve the list of groups",
        "api-partner-lang": "Language",
        "api-partner-default-lang": "Default language of your profile",
        "api-key": "Key",
        "api-value": "Value",
        "api-exemple": "Example",
        "api-getted-token": "Your API token retrieved during login",
        "api-nextlevel-token": "Your api key provided by NextLevel",
        "api-number-getted": "The number of results per page - Default: 20",
        "page-number": "The number of the page to display - Default : 1"
    },
    "projets": {
        "-selector": {
            "current": "You are currently working on this project",
            "recommandation": "We strongly recommend that you create one project per website you work on"
        },
        "actions": {
            "delete": "Delete selected projects",
            "deactivate": "Switch off",
            "deactivating": "Deactivating...",
            "edit": "Edit this project",
            "delete_successfull": "Project was successfully deleted | Projects were successfully deleted"
        },
        "columns": {
            "defaultProject": "Default project",
            "setDefault": "Set default",
            "name": "Name",
            "website": "Website",
            "filteredLinks": "Filtered links",
            "status": "Status",
            "statusActive": "Active",
            "statusInactive": "Inactive",
            "budget": "Budget",
            "emailRecipients": "Email recipients",
            "actions": "Actions"
        },
        "all": "All",
        "brieflabel": "Default project brief ",
        "briefdescription": "Insert the default brief for future orders of this project.",
        "numberProject": "You have {n} project(s)",
        "add": "Add a project",
        "backToProjects": "Go back to projects list",
        "budget": "Monthly budget (indicative)",
        "budgetmonthly": "Monthly budget (optional)",
        "concerned": "Project in question:",
        "create": "Create a new project",
        "createproject": "Create",
        "enterprojectname": "Please enter the name of the project!",
        "entervalidmail": "Please enter valid email addresses",
        "filteredLinks": "Filter my other links",
        "filteredLinksDesc": "We offer you the possibility to remove websites from the search results (for example if you already own backlinks to them).",
        "integer": "Please enter a whole number.",
        "language": "Language",
        "mailrecipient": "Mails recipients ",
        "mailrecipients": "Mails recipients (separated by a comma)",
        "mooveto": "Move to this project",
        "moovetoproject": "Move to a project",
        "modify": "Edit a project",
        "name": "Name of the project",
        "noprojectsyet": "You don't have any projects yet",
        "notsorted": "Unclassified",
        "project": "Project",
        "projects": "Projects",
        "site-anchors-type": "Anchors types accepted",
        "site-groups-blacklisted": "Topics refused",
        "spendings": "Current month's expenses",
        "supress": "Are you sure you want to delete this project?",
        "title": "My projects",
        "website": "Website",
        "website-info": "Insert the root domain (mywebsite.com) in order not to see in the search the keywords of the sites where you have already bought a link",
        "update": "Update project"
    },
    "register": {
        "society": "Company",
        "firstname": "First name",
        "lastname": "Last name",
        "email": "Email",
        "phone": "Phone",
        "address": "Address",
        "postalCode": "Postal code",
        "city": "City",
        "country": "Country",
        "tva": "VAT number",
        "password": "Password",
        "passwordConfirmation": "Password confirmation",
        "promo": "Promo code (optional)",
        "skypemessage": "If you haven't already filled in your phone number, please at least fill in your Skype for the processing of your future orders.",
        "accept": "I accept the ",
        "cgv": "Terms and Conditions",
        "cgvmessage": "By validating these terms and conditions, I expressly waive my right of withdrawal.",
        "cgvpartner": "Partner's Terms and Conditions",
        "register": "Register",
        "partner": "I want to become a partner",
        "alreadyregister": "Already registered?",
        "gains": "Partner's earnings can be transferred to credits or withdrawn",
        "gainsWarning": "WARNING : you must provide your company's name in order to withdraw your winnings",
        "alertSMS": "I agree to receive SMS messages related to orders from my sites",
        "login": "Login",
        "title": "Register",
        "error": {
            "lenght": "Minimum 6 characters",
            "number": "Minimum one digit",
            "uppercase": "Minimum one upper case",
            "lowercase": "Minimum one lower case",
            "symbol": "Minimum one special character",
            "mismatch": "Password mismatch",
            "mandatory": "This field is required",
            "society": "You must provide your company name if you want to become a partner",
            "cgv": "You must accept Terms and Conditions in order to process",
            "userAlreadyExists": "The user already exists.",
            "incorrect": "Incorrect",
            "fillAllFields": "Please, fill all required fields.",
            "phoneFormat": "Invalid format"
        }
    },
    "suivi": {
        "articles": "Articles follow-up",
        "artileswaiting": "On hold articles",
        "availablewhenpublished": "Will be available once published",
        "dateorder": "Order date",
        "datepost": "Publication date",
        "editionline": "The proposed editorial line does not suit the partner",
        "errorpage": "This page has been added by mistake by the partner",
        "invalid-date": "Invalid dates",
        "numberofkeywords": "Number of positioned keywords",
        "otherkeywords": "Other keywords",
        "otherkeywordspositionned": "Other positioned keywords of the URL",
        "keywordspositionned": "Positioned keywords of the URL",
        "seeLess": "See less...",
        "seemore": "See more... ",
        "seemorekeywords": "Show more keywords",
        "suppword": "Additional words",
        "publishedarticles": "Published articles",
        "url": "URL Information",
        "publishedon": "Article published on",
        "wantedpublication": "Wanted publication",
        "seedatas": "Check the data",
        "urldate": "URL data at the date of the order",
        "move-orders": "Are you sure to move orders",
        "in-project": "in project",
        "cannot-found-history": "We can't found complete history",
        "error": "Unable to get data"
    },
    "searchform": {
        "agency": "AGENCY MODE",
        "agent": "I represent an agency",
        "assignbudget": "Assign budget to your staff",
        "rank-domain-max": "RD max.",
        "rank-domain-min": "RD min.",
        "impressions": "Impressions",
        "impressions-min": "Impressions min.",
        "impressions-max": "Impressions max.",
        "clicks": "Clicks",
        "clicks-min": "Clicks min.",
        "clicks-max": "Clicks max.",
        "searchby": "Search",
        "searchByTheme": {
            "title": "Search by theme",
        },
        "searchByKeyword": {
            "title": "Search by keyword",
        },
        "searchByDomain": {
            "title": "Search by domain",
        },
        "searchByUrl": {
            "title": "Search by page",
        },
        "searchbykeywordlist": "Search by keyword lists",
        "searchbygsc": "Search by Google Search Console",
        "keywordsbydomain": "Keywords by domain",
        "keywordbyurl": "Keywords by URL",
        "promourl": " See only discounted URLs",
        "enterDomain": "Enter your root domain (website.com)",
        "enterValidUrl": "Enter a valid URL (http(s)://website.com/my-page)",
        "position": "Position",
        "positionmin": "Minimum position",
        "positionmax": "Maximal position",
        "volume": "Volume",
        "volumemin": "Minimum volume",
        "volumemax": "Maximum volume",
        "withkeyword": "With the keyword",
        "enter-keyword": "No result, please enter keyword",
        "noResultsEnterUrl": "No result, please enter url",
        "noResultsEnterDomain": "No result, please enter domain",
        "select-site": "No result, please select a website",
        "enterurl": "Enter your URL",
        "urlnumber": "Number of URLs",
        "keywordnumber": "Number of Keywords",
        "urlordomain": "Exact URL or domain of one your websites",
        "exportselection": "Export my selection",
        "visibility": "I want to develop my online visibility",
        "mentorship": "FULLY-MANAGED CAMPAIGN",
        "opportunity": "Opportunity analysis ",
        "analyse": "OnSite Analysis of the pages to work on",
        "popularity": "Development  of your online popularity",
        "seo": ": COMPLETE SEO",
        "offsiteseo": "OFF SITE SEO",
        "clickhere": "Click here",
        "help": "to go for a fully-managed campaign",
        "netlinking": "I want to entrust you with my netlinking",
        "budget": "Budget for a minimum of 3 months",
        "orders": "We carry out the orders",
        "tracking": "You have access to the tracking ",
        "gestion": "MANAGEMENT OF YOUR ACCOUNT IN",
        "ui": "Enjoy an adapted interface",
        "partner": "Become a trusted partner",
        "companionship": "FULLY-MANAGED CAMPAIGN",
        "noArticlesUrl": "None of the articles on NextLevel is positioned on the keywords of your URL*",
        "noarticles": "None of the articles on NextLevel is positioned on the keywords of your domain.",
        "adresssiteurl": "Type the URL of your choice (from your website). NextLevel will extract the keywords and let you know if we already have positioned articles available on those.",
        "adresssite": "Type the root domain of your website. NextLevel will extract the keywords and let you know if we already have positioned articles available on those.",
        "alreadypositionned": "Type a Keyword, we are looking for articles already positioned among our results available on NextLevel",
        "typekeyword": "Type a keyword - Advanced search is possible with, for example: \";\" multiple search available with keywords separated by a comma",
        "noRecordedFavoriteYet": "You don't have saved any favorite yet.",
    },
    "semrush": {
        "enterkey": "Please enter your SEMRush key",
        "beforeacess": "before using this feature",
        "error": "An error has happened. Is your API key",
        "iscorrect": "correct / do you have enough credits?"
    },
    "tableau-keywords": {
        "addlink": "Add a secondary link",
        "addnote": "Add a note",
        "addwords": "Add words to the existing text",
        "anchor": "Text anchor",
        "blacklist": "Blacklist URL",
        "blacklistdescription": "This URL no more will be displayed for all users, are you sure?",
        "brief": "Brief",
        "buy": "Buy (total price {price}€)",
        "categorysite": "Website category",
        "clicks": "Clicks",
        "contact": "Contact the help desk to see the data",
        "credit": "Credit my account to see the data",
        "credittoorder": "Credit my account to order",
        "date": "Date",
        "discount": "Discount",
        "general": "General",
        "grades": "Gold: premium website, Silver: medium website, Bronze: basic website",
        "impressions": "Impressions",
        "indiceURL": "Power index of the URL, 1 being the lowest and 100 the highest",
        "insteadof": " instead of",
        "keywordavailable": "Available keywords on which to buy a position",
        "keywordpositionnednumber": "Number of keywords positioned on the URL",
        "keywordtop10": "Number of keywords positioning the URL in the top 10",
        "modifynote": "Edit the note",
        "nextStep": "Next (total price: {price}€)",
        "numberkeyword": "Number of keywords",
        "numberkeywordpositionned": "Positioned keywords",
        "orderlink": "Order a link",
        "partnersite": "Partner website",
        "position": "Position",
        "pricewithoutVAT": "before VAT.",
        "promo": "Promo",
        "publicationplanned": "Planned publication",
        "publicationsoon": "Publication as soon as possible ",
        "quantity": "Average monthly search volume of the keyword in Google",
        "rank": "Rank",
        "secondarylinkanchor": "Anchor of the secondary link",
        "secondarylinkurl": "URL of the secondary link",
        "serpPosition": "Position of the keyword in Google SERP (Source: SEObserver). Ex: if top 50, keyword is between the 1st and the 50th position",
        "siteAge": "Site added date",
        "themeorglobal": "General or thematic website",
        "thesite": "The website",
        "url": "Link to be placed",
        "urlindice": "Index",
        "withoutVAT": "before VAT",
        "yourposition": "Your position",
        "yourpositionbyurl": "Your position for your website",
        "yoursite": "Your website",
        "yoururl": "Your url"
    },
    "thematique": {
        "exactsearch": "Exact search",
        "lastlogin": "Since your last login on ",
        "searchkeyword": "Search keyword",
        "title": "Theme",
        "typekeyword": "Type a keyword"
    },
    "wordpress_modal": {
        "title": "Wordpress plugin setting",
        "wordpress_api_key": "API Token",
        "check_button": "Check connection & save",
        "success": "Token valid",
        "getInfos": "Information retrieval",
        "getAuthors": "Recovery of authors",
        "getCategories": "Recovery of categories",
        "postArticles": "Publication of an article"
    },
    "config": {
        "mails_nouveau_site_partenaire": "Nouveau site partenaire",
        "mails_demande_retrait_gains": "Demande de retrait",
        "mails_refus_commande_accompagnement": "Refus commande Accompagnement",
        "mails_acceptation_commande": "Acceptation commande",
        "mails_demande_accompagnement": "Demande d'accompagnement",
        "mails_modification_demande_accompagnement": "Modification de demande d'accompagnement",
        "mails_achat_mot_cle_exact_precommande": "Achat mot-clé exact précommande",
        "mails_achats_credits_virement": "Achat de crédit par virement",
        "mails_delai_publication_depasse": "Délais de publication dépassé",
        "mails_demande_suppression_compte": "Demande de suppression de compte",
        "email_notifications_attestations": "Notification d'ajout de document fiscal",
        "admin_bulk_notif_delete": "Suppression de site(s) par un partenaire",
        "admin_bulk_notif_desactivate": "Désactivation de site(s) par un partenaire",
        "redactor_admins_ids": "Rédacteurs administrateurs",
        "redactor_corrector_ids": "Correcteurs",
        "management_nl_ids": "Gestion NL"
    },
    "api": {
        "getKeywordsByStatId": {
            "numberPlacedKeywords": "Keywords on this link ",
            "seeMoreKeywords": "See more keywords"
        }
    },
    "redactor": {
        "title": "Redactor",
        "redactors": "Writers",
        "nbWordsWriter": "Number of words per day",
        "nbWordsWrittenToday": "Number of words written today",
        "price": "Price",
        "title-tab-redactor": "Writers stats",
        "title-tab-orders": "Unassigned orders",
        "bought-keywords": "Bought keywords",
        "nbWords": "Number of words",
        "link-anchors": "Links / Anchors",
        "start-writing": "I start writing",
        "daily-words-quota": "You have written your daily word quota",
        "no-orders": "No orders",
        "orders-processed": "Orders to be processed",
        "preorders-processed": "Pre-orders to be processed",
        "customer-page": "Customer's page",
        "click-go-site": "Click here to go to the site",
        "website-title": "Title",
        "website-meta": "Meta title",
        "actual-content": "Actual page content",
        "publish-partner": "Send to partner",
        "publish-wordpress": "Publish via plugin",
        "anchor-saved": "The new anchor has been successfully registered",
        "anchor-edit": "I modify the anchor",
        "anchor-old": "Old anchor",
        "anchor-new": "New anchor",
        "anchor-confirm": "Confirm new anchor",
        "content": "Content",
        "publishdate": "Publish date",
        "refuse": "I refuse",
        "refusals": "Refused subjects",
        "recap-infos": "Summary of the main informations",
        "page": "Page",
        "link": "Link",
        "select-reason": "Select the reason",
        "dont-want": "The order is about a subject that I do not wish to deal with",
        "dont-know": "The order concerns a subject that I do not master",
        "other": "Other",
        "no-info": "No information",
        "link-anchor-present": "Link(s) and anchor(s) are detected",
        "summary-activity": "Summary of the activity over the period",
        "from": "From",
        "to": "To",
        "orders-done": "Completed orders",
        "words-done": "Number of words written",
        "earnings": "Earnings",
        "words-to-treated": "Number of words to process",
        "words-day-redactors": "Number of daily words writers can do",
        "redactor-desactivate": "Inactive redactor"
    },
    "writing": {
        "title": "Article to be written"
    },
    "crawler": {
        "exceptions": {
            "http_error": "Communication error with the website",
            "anchor_not_found": "anchor not found",
            "link_not_found": "link not found"
        }
    },
    "select": {
        "errorLoading": "The results could not be loaded.",
        "noResults": "No results found",
        "searching": "Searching…",
        "inputTooShort": "Please enter",
        "letter": "or more characters"
    },
    "accompagnement": {
        "all": "All support",
        "status": {
            "a_confirmer": "Waiting for approval",
            "a_faire": "To do",
            "en_cours": "In progress",
            "fait": "Done",
            "en_attente_credit": "Awaiting credits",
            "en_attente_retour_client": "Waiting for customer feedback",
            "termine": "Finished",
            "non_fait": "Not done"
        },
        "followup": {
            "status": {
                "todo": "To do",
                "in_progress": "In progress",
                "awaiting": "Waiting for customer feedback",
                "done": "Done"
            },
            "thematic": {
                "technical": "Technical",
                "structure": "Structure",
                "content": "Content",
                "onsite": "Onsite",
                "netlinking": "Netlinking",
                "report": "Report",
                "tree_structure": "Tree structure",
                "analytics": "Analytics",
                "others": "Autres"
            }
        },
        "action": {
            "groups": {
                "positioning": "Besoin de positionnement",
                "structure": "Structure",
                "technical": "Technique",
                "content": "Contenu (editorial et sémantique)",
                "monitoring": "Suivi mensuel"
            },
            "thematics": {
                "positioning": {
                    "audit": "Audit de l'existant",
                    "demand-analyse": "Analyse de la demande et concurrence",
                    "keyword-following": "Suivi des MC issus de l'AS dans Monitorank"
                },
                "structure": {
                    "mapping": "Mapping existant du site",
                    "seo-structure": "Elaboration de l'arborescence SEO",
                    "integration": "Intégration du mapping existant dans l'arborescence",
                    "deployment": "Déploiement de l'arborescence sur le site",
                    "recipe": "Recettage de l'arborescence",
                    "internal-mesh": "Optimisation du maillage interne"
                },
                "technical": {
                    "fix-blocking-factors": "Correction des facteurs bloquants",
                    "optimization": "Optimisation technique (chargement, paramètre…)",
                    "log-analysis": "Analyse de logs",
                    "tracking": "Tracking",
                    "recipe": "Recettage audit"
                },
                "content": {
                    "semantic-analysis": "Analyse sémantique",
                    "brief-creation": "Création de brief de contenu",
                    "recipe": "Recettage sémantique",
                    "production": "Production de contenu en interne"
                },
                "monitoring": {
                    "data": "Monitoring des données (crawl, position, logs...)",
                    "monthly": "Reporting mensuel",
                    "target-meeting": "Rendez-vous du 6ème mois pour Objectifs"
                }
            },
            "status": {
                "todo": "To come up",
                "in_progress": "In progress",
                "awaiting": "Awaiting",
                "done": "Done"
            }
        }
    },
    "withdrawal-winnings": {
        "title": "Withdrawal Winnings",
        "date": "Date",
        "invoice-name": "Invoice Name",
        "user": "User",
        "payment": "Payment",
        "payment-date": "Payment Date",
        "payment-info": "Payment Info",
        "amount-ht": "Amount HT",
        "amount-ttc": "Amount TTC",
        "type": "Type",
        "validation-error": "Validation Error",
        "validation-compta": "Validation Accounting",
        "validation-date": "Validation Date",
        "notes": "Notes",
        "actions": "Actions"
    },
    "gsc": {
        "chooseSite": "Choose your site",
        "logout": "GSC logout",
        "login": "GSC Login",
        "positionedKeyword": "Keywords with positioned articles",
        "notPositionedKeyword": "Keywords without positioned articles",
        "preorderKeyword": "Pre-order keywords",
        "noArticlesGsc": "None of the articles on GSC is not positioned on the keywords of your URL"
    },
    "date": {
        "months": {
            "january": "january",
            "february": "february",
            "march": "march",
            "april": "april",
            "may": "may",
            "june": "june",
            "july": "july",
            "august": "august",
            "september": "september",
            "october": "october",
            "november": "november",
            "december": "december"
        }
    },
    "validation": {
        "errors": {
            "amount": "Amount"
        },
        "max": {
            "numeric": "value is too high"
        },
        "string": {
            "too-short": "Text is too short"
        }
    },
    "group-site": {
        "modal": {
            "partner": "Partner (leave blank if the site is a NextLevel site)",
            "urls": "URLs (with avec http / https), one per line",
            "activate_sites": "Activate sites",
            "confirm": {
                "activationwebsites-text": "Confirm all selected sites activation"
            }
        },
        "title": "Sites",
        "valid-save-site": "Your sites hava been added and enabled",
        "valid-reactive-sites": "Selected sites have been reactivated",
        "valid-active-sites": "Selected sites have been activated"
    },
    "credits": {
        "title": "Credits",
        "buy": "Buy credits",
        "invoices": "Mes factures",
        "prefix": "Credits",
        "amount_before": "Balance before",
        "amount_after": "Balance after",
        "amount": "Amount",
        "event": "Event"
    },
    "sellingwebsite": {
        "label": {
            "potentialGain": "Potential gains",
            "saleable": "Saleable URLs"
        }
    },
    "paymentTunnel": {
        "payCampaign": "Campaign quotations",
        "continue": "Continue",
        "buyCredits": "Buy credits",
        "selectCampaign": "Sélect your campaign",
        "bankTransfer": {
            "title": "Bank transfer"
        }
    }
}
